import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ValueProposition() {
  const benefits = ['Generate 5000 GWh of electricity from waste methane', 'Save municipalities up to $30M in waste costs', 'Reduce CO2 emissions significantly', 'Create a circular waste-to-energy ecosystem', 'Unlock carbon credit revenue streams'];
  return <section className="py-20 bg-slate-950 border-t border-slate-900" data-id="element-341">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342">
        <div className="bg-gradient-to-br from-slate-900 to-slate-950 rounded-3xl border border-slate-800 p-8 md:p-16 relative overflow-hidden" data-id="element-343">
          {/* Decorative glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-[80px]" data-id="element-344"></div>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-345">
            <div data-id="element-346">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-347">
                Affordable, Clean, and Scalable Energy
              </h2>
              <p className="text-lg text-slate-400 mb-8" data-id="element-348">
                We transform environmental liabilities into economic assets,
                providing a win-win scenario for cities, investors, and the
                planet.
              </p>

              <ul className="space-y-4" data-id="element-349">
                {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-350">
                    <CheckCircle2 className="w-6 h-6 text-emerald-400 shrink-0 mt-0.5" data-id="element-351" />
                    <span className="text-slate-300 font-medium" data-id="element-352">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="relative h-full min-h-[300px] rounded-2xl overflow-hidden border border-emerald-500/30 bg-slate-900 group" data-id="element-353">
              {/* AI Bio-Digester Plant Image */}
              <img src="https://cdn.magicpatterns.com/uploads/eGNsqEGwCLD5jKpVkFcnqx/AI2Bin2BAD2Bplant.webp" alt="AI-optimized bio-digester facility" className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-70 transition-opacity duration-700" data-id="element-354" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/70 to-slate-900/50" data-id="element-355"></div>

              <div className="relative z-10 h-full flex flex-col justify-end p-6" data-id="element-356">
                <div className="text-5xl font-extrabold text-white mb-2 drop-shadow-lg" data-id="element-357">
                  85%+
                </div>
                <div className="text-emerald-400 font-semibold tracking-wider uppercase text-sm" data-id="element-358">
                  AI-Optimized System Efficiency
                </div>
                <p className="text-slate-300 text-sm mt-2" data-id="element-359">
                  Our advanced bio-digester facilities leverage AI to maximize
                  energy output
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}